<template>
  <v-rating :value="roundedValue" half-increments length="5" :background-color="backgroundColor" :color="color" :empty-icon="emptyIcon" :readonly="readonly" :size="size" :dense="dense">
    <template #item="{ isFilled, isHalfFilled }" v-if="customStar">
      <FullStar :width="size" v-if="isFilled" :class="{ dense }" />
      <HalfStar :width="size" v-else-if="isHalfFilled" :class="{ dense }" />
      <EmptyStar :width="size" v-else :class="{ dense }" />
    </template>
  </v-rating>
</template>

<script>
import FullStar from '@/assets/icons/star-rating-full.svg'
import HalfStar from '@/assets/icons/star-rating-half.svg'
import EmptyStar from '@/assets/icons/star-rating-empty.svg'

export default {
  props: {
    value: { type: Number, required: true },
    dense: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    customStar: { type: Boolean, default: false },
    backgroundColor: { type: String, default: 'primary lighten-3' },
    color: { type: String, default: 'primary' },
    emptyIcon: { type: String, required: false }
  },

  components: { FullStar, HalfStar, EmptyStar },

  data() {
    return {
      sizes: {
        small: '15px',
        normal: '32px',
        large: '48px'
      }
    }
  },

  computed: {
    size() {
      if (this.large) return this.sizes.large
      if (this.small) return this.sizes.small
      return this.sizes.normal
    },
    roundedValue() {
      const roundedValue = Math.round(this.value)
      const half = roundedValue - this.value === 0.5
      return roundedValue > this.value && !half ? roundedValue : this.value
    }
  }
}
</script>

<style>
.dense {
  margin-left: -3px;
  margin-right: -3px;
}
</style>
